// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --ion-background-color: white !important;
}

.info-icon {
  font-size: 24px;
  color: var(--ion-color-medium);
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/client/objective-client/objective-form/objective-form.component.scss"],"names":[],"mappings":"AAAA;EACI,wCAAA;AACJ;;AAEA;EACI,eAAA;EACA,8BAAA;AACJ","sourcesContent":["ion-content {\r\n    --ion-background-color: white !important;\r\n}\r\n\r\n.info-icon {\r\n    font-size: 24px;\r\n    color: var(--ion-color-medium);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
